import { render } from "./User-Edit.vue?vue&type=template&id=73385742"
import script from "./User-Edit.vue?vue&type=script&lang=js"
export * from "./User-Edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__